import ProductHistory from './ProductHistory';

export default ProductHistory;
